import React from 'react'
import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { useModalState } from 'src/Modal/ModalStateContext'
import { ModalFormId } from 'src/components/ModalForms'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import {
  StandardButtonSize,
  StandardButtonVariant,
} from 'src/components/Reusable/Buttons'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { AuditBotModal } from '../modals/AuditBotModal'
import {
  CheckWithEroButtonContainer,
  CheckWithEroIcon,
  CheckWithEroStyledButton,
} from './CheckWithEroButton.styles'

export const CheckWithEroButton = ({
  controlId,
  isDisabled = false,
  customText,
}: {
  controlId: string
  currentAudit?: AuditRecord
  isDisabled?: boolean
  customText?: string | JSX.Element
}): JSX.Element => {
  const canStartAuditRun = useCanPerformAction(CAPABILITY.CAN_START_AUDIT_SCANS)
  const { openModal } = useModalState()

  const startAuditScan = async () => {
    openModal(ModalFormId.RUN_AUDITBOT)
  }

  const disabledEro = isDisabled

  const isButtonDisabled = !canStartAuditRun || disabledEro

  return (
    <>
      <CheckWithEroStyledButton
        variant={
          customText
            ? StandardButtonVariant.SECONDARY
            : StandardButtonVariant.PRIMARY
        }
        buttonSize={StandardButtonSize.SMALL}
        onClick={startAuditScan}
        disabled={isButtonDisabled}
      >
        <CheckWithEroButtonContainer>
          {!customText && <CheckWithEroIcon $isDisabled={disabledEro} />}
          {customText || 'Control Test'}
        </CheckWithEroButtonContainer>
      </CheckWithEroStyledButton>
      <AuditBotModal controlId={controlId} />
    </>
  )
}
